// extracted by mini-css-extract-plugin
module.exports = {"banner":"PreviewNotice_banner__2TdUB","fadeInFromBottomAnimation":"PreviewNotice_fadeInFromBottomAnimation__3CLr9","fadeInAnimation":"PreviewNotice_fadeInAnimation__2vILa"};